import { ApiClient } from '../lib/api';

export class ReportingService {
  private api: ApiClient;

  constructor(baseURL: string, stage: string) {
    this.api = new ApiClient(`${baseURL}/${stage}/reporting-service-${stage}`, stage);
  }

  async getLeadReport(startDate: string, endDate: string): Promise<string> {
    const response = await this.api['instance'].get(
      `/lead-report?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      { responseType: 'text' }
    );
    return JSON.parse(response.data as string).body as string;
  }

  async getQuoteReport(startDate: string, endDate: string): Promise<string> {
    const response = await this.api['instance'].get(
      `/quote-report?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      { responseType: 'text' }
    );
    return JSON.parse(response.data as string).body as string;
  }

  async getGeneralFilterReport(startDate: string, endDate: string): Promise<string> {
    const response = await this.api['instance'].get(
      `/general-filter?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
      { responseType: 'text' }
    );
    return JSON.parse(response.data as string).body as string;
  }
} 